import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bc7t8g6dg8: FaireBrandEntity = {
  token: "b_bc7t8g6dg8",
  type: "brand",
  name: "Rich & Pour",
  avatarUrl:
    "https://cdn.faire.com/fastly/ecaf3bfd8d177edce22d55d0a4df2e1e79ec64f51672d0b192c22e0de6313e9b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bb1503b77336ec1055bee787ab8feb546ec387ad644c6b819d4a0433c346b248.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ecaf3bfd8d177edce22d55d0a4df2e1e79ec64f51672d0b192c22e0de6313e9b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bb1503b77336ec1055bee787ab8feb546ec387ad644c6b819d4a0433c346b248.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.5,
  reviewCount: 4,
  isInsider: true,
  description:
    "Rich & Pour looseleaf blends feature nostalgic dessert and Asian-inspired flavors. We create products that allow looseleaf blends to seamlessly fit with even the busiest of lifestyles.\n\nWe’re passionate about tea’s ability to promote wellness and foster community, and we work to continue bridging cultural gaps through our East x West branding. We also pride ourselves on sustainability. We source our blends responsibly and house them in biodegradable packaging.\n\nWe are AAPI-owned and female-founded.\n",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:28:23.609Z",
    importedBy: "entity-db-cli",
  },
};
